<div class="smart-table">
  <div class="table-shell">
    <div class="table-state" *ngIf="loading">Loading table...</div>
    <div class="table-state error" *ngIf="!loading && errorMessage">{{ errorMessage }}</div>
    <div class="table-state" *ngIf="!loading && !errorMessage && rows.length === 0">{{ emptyStateMessage }}</div>

    <ng-container *ngIf="!loading && !errorMessage && rows.length > 0">
      <ng-container
        *ngTemplateOutlet="tableTemplate; context: {
          columns: columns,
          rows: rows,
          tableHeight: tableHeight,
          emptyMessage: emptyStateMessage,
          scope: 'main'
        }"
      ></ng-container>

      <div class="table-footer">
        <div class="table-feedback">
          <!-- <span class="sync-message" *ngIf="syncMessage">{{ syncMessage }}</span> -->
          <span class="submit-message success" *ngIf="submitMessage">{{ submitMessage }}</span>
          <span class="submit-message error" *ngIf="submitErrorMessage">{{ submitErrorMessage }}</span>
        </div>

        <div class="table-actions" [ngClass]="submitButtonAlignClass" *ngIf="hasSubmitAction">
          <button class="submit-button" type="button" [disabled]="submitInFlight" (click)="submitTable()">
            {{ submitInFlight ? 'Submitting...' : submitButtonLabel }}
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-template
  #tableTemplate
  let-columns="columns"
  let-rows="rows"
  let-tableHeight="tableHeight"
  let-emptyMessage="emptyMessage"
  let-scope="scope"
>
  <div class="table-scroll" [style.max-height]="scope === 'main' ? null : tableHeight">
    <table class="smart-table-grid">
      <thead>
        <tr>
          <th *ngFor="let column of columns; trackBy: trackByColumn" [style.width]="getColumnWidth(column)">
            {{ getHeaderLabel(column, scope) }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr
          *ngFor="let row of rows; let rowIndex = index; trackBy: trackByRow"
          [ngClass]="getRowClasses(scope, row, rowIndex)"
          (click)="onRowClick(scope, row, rowIndex, $event)"
        >
          <td *ngFor="let column of columns; trackBy: trackByColumn" [ngClass]="getCellClasses(column)">
            <ng-container *ngIf="isSliderColumn(column); else standardCell">
              <div class="slider-cell">
                <div class="slider-metadata">
                  <span class="slider-current">{{ getDisplayValue(row, column) }}</span>
                  <span class="slider-range">
                    {{ getSliderMin(row, column) }} - {{ getSliderMax(row, column) }}
                  </span>
                </div>
                <input
                  class="slider-input"
                  type="range"
                  [min]="getSliderMin(row, column)"
                  [max]="getSliderMax(row, column)"
                  [step]="getSliderStep(row, column)"
                  [value]="getInputValue(row, column)"
                  (input)="onSliderChange(scope, rowIndex, row, column, $event)"
                  (change)="onSliderCommit(scope, rowIndex, row, column)"
                />
              </div>
            </ng-container>

            <ng-template #standardCell>
              <ng-container *ngIf="isProgressColumn(column); else nonProgressCell">
                <div class="progress-cell">
                  <div class="progress-track">
                    <span
                      class="progress-fill"
                      [style.width.%]="getProgressPercent(row, column)"
                      [style.background]="getProgressColor(row, column)"
                    ></span>
                  </div>
                  <span class="progress-label">{{ getProgressLabel(row, column) }}</span>
                </div>
              </ng-container>

              <ng-template #nonProgressCell>
                <ng-container *ngIf="isStatusColumn(column); else nonStatusCell">
                  <span class="status-pill" [style.background]="getStatusColor(row, column)">
                    {{ getStatusLabel(row, column) }}
                  </span>
                </ng-container>

                <ng-template #nonStatusCell>
                  <ng-container *ngIf="isDropdownColumn(column); else nonDropdownCell">
                    <div class="dropdown-cell">
                      <select
                        class="cell-select"
                        [value]="getDropdownValue(row, column)"
                        (focus)="onDropdownFocus(rowIndex, row, column)"
                        (change)="onDropdownChange(scope, rowIndex, row, column, $event)"
                      >
                        <option value="">{{ column.dropdownPlaceholder || 'Select' }}</option>
                        <option
                          *ngFor="let option of getDropdownOptions(rowIndex, row, column)"
                          [value]="option.value"
                          [disabled]="option.disabled"
                        >
                          {{ option.label }}
                        </option>
                      </select>
                      <span class="dropdown-loading" *ngIf="isDropdownLoading(rowIndex, row, column)">Loading...</span>
                    </div>
                  </ng-container>

                  <ng-template #nonDropdownCell>
                    <ng-container *ngIf="isPopupTriggerColumn(column); else editableOrDisplayCell">
                      <button class="cell-action" type="button" (click)="openPopup(row, column, $event)">
                        <span [innerHTML]="getActionLabel(row, column)"></span>
                      </button>
                    </ng-container>

                    <ng-template #editableOrDisplayCell>
                      <ng-container *ngIf="isEditableColumn(column); else displayCell">
                        <input
                          class="cell-input"
                          [type]="isNumberLikeColumn(column) ? 'number' : 'text'"
                          [placeholder]="column.placeholder || ''"
                          [value]="getInputValue(row, column)"
                          (input)="onInputChange(scope, rowIndex, row, column, $event)"
                          (change)="onInputCommit(scope, rowIndex, row, column)"
                        />
                      </ng-container>

                      <ng-template #displayCell>
                        <span class="cell-value">{{ getDisplayValue(row, column) }}</span>
                      </ng-template>
                    </ng-template>
                  </ng-template>
                </ng-template>
              </ng-template>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<div class="popup-backdrop" *ngIf="popupOpen" (click)="closePopup()">
  <div class="popup-shell" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h3 class="popup-title">{{ popupTable.title || 'Details' }}</h3>
      <button class="popup-close" type="button" (click)="closePopup()">Close</button>
    </div>

    <div class="table-state" *ngIf="popupTable.loading">Loading table...</div>
    <div class="table-state error" *ngIf="!popupTable.loading && popupTable.errorMessage">{{ popupTable.errorMessage }}</div>
    <div class="table-state" *ngIf="!popupTable.loading && !popupTable.errorMessage && popupTable.rows.length === 0">
      {{ popupTable.emptyStateMessage }}
    </div>

    <ng-container *ngIf="!popupTable.loading && !popupTable.errorMessage && popupTable.rows.length > 0">
      <ng-container
        *ngTemplateOutlet="tableTemplate; context: {
          columns: popupTable.columns,
          rows: popupTable.rows,
          tableHeight: popupTable.tableHeight,
          emptyMessage: popupTable.emptyStateMessage,
          scope: 'popup'
        }"
      ></ng-container>
    </ng-container>
  </div>
</div>
